import Swal from "sweetalert2";
import axios from "axios";

export const handleOnePayPayment = async (
  bookingSidebar,
  totalamount,
  totaldays,
  guestDetails,
  setLoading
) => {
  if (Object.values(guestDetails).some((field) => !field)) {
    Swal.fire("Error", "All guest information fields are required.", "error");
    return;
  }

  console.log("Sending OnePay Payment Request:", {
    totalamount,
    totaldays,
    bookingSidebar,
    guestDetails,
  });

  setLoading(true);
  try {
    // Call backend to get OnePay URL
    const response = await axios.post("/api/payment/onepay/create", {
      totalamount,
      totaldays,
      bookingSidebar,
      guestDetails,
    });
    console.log("OnePay Payment URL Response:", response.data);

    if (response.data.paymentUrl) {
      // Redirect to OnePay payment page
      window.location.href = response.data.paymentUrl;
    } else {
      Swal.fire(
        "Error",
        "Failed to initiate OnePay payment. Please try again.",
        "error"
      );
    }
  } catch (error) {
    console.error("Error initiating OnePay payment:", error);
    Swal.fire(
      "Error",
      "Failed to initiate OnePay payment. Please try again.",
      "error"
    );
  } finally {
    setLoading(false);
  }
};
